// extracted by mini-css-extract-plugin
export default {"root":"app-react-sidebar-EnvironmentSidebar-module__root","closeBtn":"app-react-sidebar-EnvironmentSidebar-module__closeBtn"};